import config from 'config';
import axios from 'helpers/axios';

const uploadDocumentRequest = (file) => {
  const formData = new FormData();
  formData.append('document', file);
  return axios({
    method: 'post',
    url: `${config.apiUrl}/document/upload`,
    data: formData,
  });
};

const createApplicationRequest = (data) =>
  axios({
    method: 'post',
    url: `${config.apiUrl}/applications`,
    data,
  });

export { createApplicationRequest, uploadDocumentRequest };
